var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2051 12.7311L6.73005 24.2061C6.4986 24.4376 6.315 24.7123 6.18973 25.0148C6.06447 25.3172 6 25.6413 6 25.9686C6 26.2959 6.06447 26.6201 6.18973 26.9225C6.315 27.2249 6.4986 27.4997 6.73005 27.7311C6.96151 27.9626 7.23628 28.1462 7.53869 28.2714C7.8411 28.3967 8.16523 28.4612 8.49255 28.4612C8.81988 28.4612 9.144 28.3967 9.44641 28.2714C9.74882 28.1462 10.0236 27.9626 10.2551 27.7311L19.9801 18.0311L29.6801 27.7311C29.9115 27.9626 30.1863 28.1462 30.4887 28.2714C30.7911 28.3967 31.1152 28.4612 31.4425 28.4612C31.7699 28.4612 32.094 28.3967 32.3964 28.2714C32.6988 28.1462 32.9736 27.9626 33.2051 27.7311C33.4365 27.4997 33.6201 27.2249 33.7454 26.9225C33.8706 26.6201 33.9351 26.2959 33.9351 25.9686C33.9351 25.6413 33.8706 25.3172 33.7454 25.0148C33.6201 24.7123 33.4365 24.4376 33.2051 24.2061L21.7301 12.7311C21.4988 12.4994 21.224 12.3155 20.9216 12.19C20.6192 12.0646 20.295 12 19.9676 12C19.6401 12 19.3159 12.0646 19.0135 12.19C18.7111 12.3155 18.4363 12.4994 18.2051 12.7311Z",
    fill: "#AEB0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.b255aba0b7ed9d81324507632b915efe.svg";
export { ForwardRef as ReactComponent };